<template>
  <FormulateInput
    v-bind="field"
    validation-behavior="live"
    class="p-0"
    :value="computedValue"
    :fullObject="fullObject"
    :optionsGetter="computedOptionsGetter"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event || [])"
  />
</template>

<script>
import * as DeliveryNote from '@/services/rest-api/lib/customer/delivery-note'

export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    customerId: {},
    isShowingData: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null
      if (Array.isArray(this.value) && this.value.length === 0) return null

      return this.value
    },
    computedOptionsGetter() {
      if (this.customerId === null || this.customerId === undefined) return

      return DeliveryNote.get(this.customerId)
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      if (Array.isArray(this.value) && this.value.length === 0) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', newValue)
    },
  },
}
</script>
